/**
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export {
  getBigQueryDocumentIndexer,
  getBigQueryDocumentRetriever,
} from './bigquery.js';
export {
  getFirestoreDocumentIndexer,
  getFirestoreDocumentRetriever,
} from './firestore.js';
export { vertexAiIndexerRef, vertexAiIndexers } from './indexers.js';
export { vertexAiRetrieverRef, vertexAiRetrievers } from './retrievers.js';
export {
  VertexAIVectorIndexerOptionsSchema,
  VertexAIVectorRetrieverOptionsSchema,
  type DocumentIndexer,
  type DocumentRetriever,
  type Neighbor,
  type VectorSearchOptions,
  type VertexAIVectorIndexerOptions,
  type VertexAIVectorRetrieverOptions,
} from './types.js';
